module.exports = __webpack_public_path__ + "images/index/img04.d7680ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/shue/img04.jpg
// module id = 0ula
// module chunks = 21